exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\nh1[data-v-5b2d5ecc] {\n  color: blue;\n}\n", "", {"version":3,"sources":["/root/workspace/ylw-web_MMhF/src/views/src/views/Test.vue"],"names":[],"mappings":";AAaA;EACA,YAAA;CACA","file":"Test.vue","sourcesContent":["<template>\n    <div>\n      <h1>这是新页面</h1>\n    </div>\n  </template>\n   \n  <script>\n  export default {\n    name: 'NewPage'\n  }\n  </script>\n   \n  <style scoped>\n  h1 {\n    color: blue;\n  }\n  </style>"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5b2d5ecc","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Test.vue
// module id = qndo
// module chunks = 1